<script setup>
import {computed} from 'vue'
import PageContentContent from "./PageContentContent.vue"
import {usePageContentDataStore} from '@/stores/pageContentData'

const props = defineProps({
    pageSectionLinkId: Number,
    area: String
})

const pageContentDataStore = usePageContentDataStore()

// Computed properties
const pageContentLinkData = computed(() => {
    return pageContentDataStore.items
        .filter(o => o.pageSectionLinkId === props.pageSectionLinkId && o.contentArea === props.area)
})
</script>

<template>
    <div v-if="pageContentLinkData.length" class="card-body p-0 pb-1">
        <div class="list-group list-group-flush">
            <PageContentContent v-for="(o, i) in pageContentLinkData" :key="o.id" :content-index="i"
                                :page-content-link-id="o.id"/>
        </div>
    </div>
</template>